import ArticleTeaser from 'gatsby-theme-husky/src/components/ArticleTeaser/ArticleTeaser';

import './ArticleTeaserOverride.scss';

export default ArticleTeaser;
